import { render } from "./LinkToRecipientSectionEMROATS.vue?vue&type=template&id=2cf8d69a&scoped=true"
import script from "./LinkToRecipientSectionEMROATS.vue?vue&type=script&lang=js"
export * from "./LinkToRecipientSectionEMROATS.vue?vue&type=script&lang=js"

import "./LinkToRecipientSectionEMROATS.vue?vue&type=style&index=0&id=2cf8d69a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf8d69a"],['__file',"src/components/LinkToRecipientSectionEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cf8d69a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cf8d69a', __exports__)) {
    api.reload('2cf8d69a', __exports__)
  }
  
  module.hot.accept("./LinkToRecipientSectionEMROATS.vue?vue&type=template&id=2cf8d69a&scoped=true", () => {
    api.rerender('2cf8d69a', render)
  })

}


export default __exports__